var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C11.9033 1 15 4.03293 15 7.69238C15 8.48934 14.6067 9.60297 13.875 10.9229C13.1611 12.2107 12.1971 13.5696 11.2139 14.8213C10.2336 16.0691 9.25075 17.1901 8.51172 18C8.32505 18.2046 8.15094 18.3866 8 18.5479C7.84906 18.3866 7.67495 18.2046 7.48828 18C6.74925 17.1901 5.76637 16.0691 4.78613 14.8213C3.80288 13.5696 2.83889 12.2107 2.125 10.9229C1.39335 9.60297 1.00002 8.48934 1 7.69238C1 4.03293 4.09668 1 8 1Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 5.61542C9.2525 5.61552 10.2004 6.58217 10.2004 7.69257C10.2003 8.80286 9.25242 9.76961 8.00024 9.76971C6.74797 9.76971 5.80018 8.80292 5.80005 7.69257C5.80005 6.58212 6.74789 5.61542 8.00024 5.61542Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.e9d32af437465dc41ad80121e2355b49.svg";
export { ForwardRef as ReactComponent };